// extracted by mini-css-extract-plugin
module.exports = {"root":"DividerVertical_root__gqpV7"};